import GSAP from 'gsap';
import MouseFollower from 'mouse-follower';

MouseFollower.registerGSAP(GSAP);

export default class Cursor {
	constructor() {
		this.instance = new MouseFollower({
			container: document.body,
			speed: 0.55,
			skewing: 2,
			hideOnLeave: true,
			stateDetection: {
				'-pointer': 'a,button',
			},
		});
	}

	destroy() {
		this.instance?.destroy();
		this.instance = null;
	}
}
